module.exports = __webpack_public_path__ + "static/media/S42_black.2aa66303.png";